import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useMemo } from "react";
import { ImageSizeMap, defaultDescription, defaultEmptyImg, emptyConfigSearch, emptySearch, noMedia, noMessage, noPermission, noTask, previewEmpty, rootClass, unarrivedTime } from "./constant.js";
import "./index.css";
const Empty = (props)=>{
    const { className, style, imageStyle, image = defaultEmptyImg, title, description = defaultDescription, action, size = 'small' } = props;
    const emptyImageStyle = useMemo(()=>{
        const _size = ImageSizeMap[size];
        return {
            ...imageStyle || {},
            fontSize: _size,
            height: _size,
            width: _size
        };
    }, [
        size,
        imageStyle
    ]);
    let imageNode = null;
    imageNode = 'string' == typeof image ? /*#__PURE__*/ jsx("img", {
        alt: 'empty',
        src: image,
        style: emptyImageStyle
    }) : image;
    return /*#__PURE__*/ jsxs("div", {
        className: classnames(className, rootClass),
        style: style,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-image`,
                style: emptyImageStyle,
                children: imageNode
            }),
            title && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-title`,
                children: title
            }),
            description && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-description`,
                children: description
            }),
            action && /*#__PURE__*/ jsx("div", {
                className: `${rootClass}-action`,
                children: action
            })
        ]
    });
};
Empty.NoData = defaultEmptyImg;
Empty.EmptySearch = emptySearch;
Empty.NoMedia = noMedia;
Empty.NoMessage = noMessage;
Empty.NoPermission = noPermission;
Empty.PreviewEmpty = previewEmpty;
Empty.UnarrivedTime = unarrivedTime;
Empty.NoTask = noTask;
Empty.EmptyConfigSearch = emptyConfigSearch;
const empty = Empty;
export { empty as default };
